import { action, observable } from 'mobx';
import * as api from '../services/api';
import UserStore from './common/UserStore';

class RiderAndOutletPartnerStore {
    @observable staffMembers = [];
    positionAbbreviations = {
        "territory manager": "TM",
        "business manager": "BM",
        "junior business manager": "JBM",
        "senior outlet manager": "SOM",
        "outlet manager": "OM",
        "senior assistant outlet manager": "SAOM",
        "assistant outlet manager": "AOM",
        "outlet partner": "OP",
        "outlet partner (training)": "OP (T)",
        "hybrid partner": "HP",
        "rider": "R",
        "casual worker": "CW",
        "ambassador": "A",
        "mit (existing outlet)": "M (E)",
        "mit (new outlet)": "M (N)",
        "technician": "T",
    };

    rankPriority = {
        "territory manager": 1,
        "business manager": 2,
        "junior business manager": 3,
        "senior outlet manager": 4,
        "outlet manager": 5,
        "senior assistant outlet manager": 6,
        "assistant outlet manager": 7,
        "outlet partner": 8,
        "outlet partner (training)": 9
    };

    @action getActiveStaffMembers = () => {
    this.staffMembers = [];

    api.getActiveStaffMembers()
        .then((res) => {
            if (res) {

                const resultWithAbbreviations = res.map((member) => {
                    const key = member.position?.toLowerCase() || "";
                    return {
                        ...member,
                        rankShort: this.positionAbbreviations[key] || null,
                    };
                });

                const sorted = resultWithAbbreviations.sort((a, b) => {
                    const keyA = a.position?.toLowerCase() || "";
                    const keyB = b.position?.toLowerCase() || "";

                    const rankA = this.rankPriority[keyA] ?? Infinity;
                    const rankB = this.rankPriority[keyB] ?? Infinity;

                    if (!a.rankShort && !b.rankShort) {
                        return a.name.localeCompare(b.name);
                    }

                    if (!a.rankShort && b.rankShort) return 1;
                    if (a.rankShort && !b.rankShort) return -1;

                    if (rankA === rankB) {
                        return a.name.localeCompare(b.name);
                    }

                    return rankA - rankB;
                });

                this.staffMembers = sorted;
            }
        })
        .catch((err) => {
            UserStore.message = err.message;
        });
    };
}

const store = new RiderAndOutletPartnerStore();
export default store;